import { barClasses } from "@mui/x-charts/BarChart";

const bonusOverviewStyles = {
  content: { maxWidth: "70rem", margin: "0 auto" },
  heading: { textAlign: "center", marginBottom: "1.625rem" },
  card: { height: "15.75rem" },
  cardContent: { padding: "1.5rem", height: "100%" },
  progress: {
    borderLeft: "0.25rem solid",
    borderColor: "primary.main",
    "& .MuiCardContent-root": { paddingLeft: "1.25rem" },
  },
  success: { backgroundColor: "action.hover" },
  successContent: {
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    gap: "0.75rem",
  },
  row: { justifyContent: "space-between", alignItems: "center" },
  rating: { alignItems: "center", gap: "0.5rem" },
  ratingGroup: { height: "5.375rem" },
  categories: { maxHeight: "7rem", overflowY: "auto" },
  chartCard: {
    padding: "1.5rem",
    marginTop: "1.5rem",
    minHeight: "38rem",
  },
  chartHeading: { marginBottom: "3.75rem" },
  chartContent: { minWidth: "67rem" },
  chart: { position: "relative", height: "17.5rem" },
  chartColumns: { position: "absolute", inset: 0 },
  axis: { width: "11rem", flexShrink: 0 },
  monthColumn: {
    position: "relative",
    width: "4rem",
    flexShrink: 0,
    textAlign: "center",
    "& > .MuiTypography-root": { position: "absolute", left: 0, width: "100%" },
  },
  currentMonthColumn: { width: "8rem", backgroundColor: "action.hover", borderRadius: "0.25rem" },
  barChart: {
    "& .MuiChartsAxis-tickLabel": { typography: "caption", fill: "currentColor", color: "text.secondary" },
    [`& .${barClasses.element}[data-bonus-bar='current']`]: {
      transform: "translateX(2rem)",
      stroke: "currentColor",
      color: "primary.light",
      strokeDasharray: "2 2",
    },
    [`& .${barClasses.label}`]: {
      typography: "subtitle2",
      transform: "translateY(-0.3125rem)",
      strokeWidth: "0.3125rem",
      paintOrder: "stroke",
    },
    "& .bonusCurrentBarLabel": { transform: "translate(2rem, -0.3125rem)" },
    "&& .MuiChartsReferenceLine-line": { stroke: "currentColor", color: "primary.main" },
    "&& .MuiChartsReferenceLine-label": { typography: "caption" },
  },
  month: { bottom: "2.5rem" },
  year: { bottom: "1.25rem", color: "text.secondary" },
  running: { bottom: 0, color: "primary.main" },
  table: {
    tableLayout: "fixed",
    marginTop: "1.375rem",
    borderTop: "0.0625rem solid",
    borderColor: "divider",
    "& .MuiTableCell-root": { borderBottom: 0, color: "inherit" },
  },
  tableRow: { height: "3.5rem", backgroundColor: "action.hover" },
  amountRow: { backgroundColor: "action.selected", color: "primary.main" },
  tableLabel: { padding: "0.5rem" },
  tableCell: { textAlign: "center", padding: "0.125rem" },
};

export default bonusOverviewStyles;
